export default __webpack_public_path__ + "static/media/ReportIcon-Skull-MS.dc68c960.jpg";